import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { listPayments } from '../../services';
import DataTable from '../../components/DataTable';
import UserSearchSelect from '../../components/UserSearchSelect';

const PAGE_SIZE = 20;

function getErrorMessage(error) {
  return error.response?.data?.error || error.response?.data?.message || error.message || 'Request failed';
}

const columns = [
  { key: 'id', label: 'ID', sortable: true },
  { key: 'username', label: 'User' },
  { key: 'subscription_id', label: 'Subscription ID' },
  {
    key: 'amount',
    label: 'Số tiền',
    sortable: true,
    render: (row) => row.amount?.toLocaleString('vi-VN', { minimumFractionDigits: 2 }),
  },
  {
    key: 'before_balance',
    label: 'Số dư trước',
    render: (row) => row.before_balance?.toLocaleString('vi-VN', { minimumFractionDigits: 2 }),
  },
  {
    key: 'after_balance',
    label: 'Số dư sau',
    render: (row) => row.after_balance?.toLocaleString('vi-VN', { minimumFractionDigits: 2 }),
  },
  {
    key: 'created_at',
    label: 'Thời gian',
    sortable: true,
    render: (row) => new Date(row.created_at).toLocaleString('vi-VN'),
  },
];

export default function PaymentsTab() {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [sortBy, setSortBy] = useState('id');
  const [sortDir, setSortDir] = useState('desc');
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    listPayments({
      userIds: selectedUsers.map((u) => u.id),
      sortBy,
      sortDir,
      page,
      pageSize: PAGE_SIZE,
    })
      .then((data) => {
        if (cancelled) return;
        setItems(data.items);
        setTotal(data.total);
      })
      .catch((error) => {
        if (!cancelled) toast.error(getErrorMessage(error));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [selectedUsers, sortBy, sortDir, page]);

  return (
    <div className="space-y-3">
      <div className="rounded-xl border border-cyan-100 bg-white p-3">
        <UserSearchSelect
          value={selectedUsers}
          onChange={(users) => {
            setSelectedUsers(users);
            setPage(1);
          }}
          multiple
          placeholder="Lọc theo user..."
        />
      </div>

      <DataTable
        columns={columns}
        data={items}
        isLoading={isLoading}
        sortBy={sortBy}
        sortDir={sortDir}
        onSortChange={(nextSortBy, nextSortDir) => {
          setSortBy(nextSortBy);
          setSortDir(nextSortDir);
        }}
        page={page}
        pageSize={PAGE_SIZE}
        total={total}
        onPageChange={setPage}
      />
    </div>
  );
}
